export enum NavigationStoreStatus {
  INITIALIZING = 0,
  LOADED = 1,
  DESTROYED = 2,
}
